module.exports = __webpack_public_path__ + "static/media/fullscreen_white.236c0504.svg";